import { lazy } from 'react';
import type { AnyObject, ScreenItem } from 'shared/src/types';
import { Screens } from './pages/Screens/Screens.page';
import { FragmentScreens } from './pages/FragmentScreens/FragmentScreens.page';
import { WebViewScreen } from './pages/WebView';
import { WEB_ROUTE_PATHS } from 'shared/src/webRoutePaths';

type CommonScreenParams<T> = Partial<{
  instanceId: string;
  next_token: string;
  screen_name: string;
}> &
  T;

export type ScreensPageParamList = {
  BrandHome: CommonScreenParams<AnyObject>;
  WebViewScreen: CommonScreenParams<{ url: string; title?: string }>;
};

const devOnlyScreens: ScreenItem[] = __DEV__
  ? [
      {
        name: 'ScreenRenderer',
        component: lazy(() =>
          import('./pages/ScreenRenderer').then(m => ({
            default: m.ScreenRenderer,
          })),
        ),
        path: '/screen-renderer/:type',
        options: {
          title: 'Screen Renderer',
        },
      },
    ]
  : [];

export const ScreensPageScreens: ScreenItem[] = [
  {
    name: 'Screens',
    component: Screens,
    path: WEB_ROUTE_PATHS.Screens,
    options: {
      title: '에이블리 스토어 - 에이블리',
    },
    convertParams: props => {
      const formattedExtras =
        typeof props.extras === 'string'
          ? (() => {
              try {
                return JSON.parse(props.extras as string);
              } catch {
                return {};
              }
            })()
          : props.extras;

      return {
        instanceId: props.instanceId,
        ...formattedExtras,
      };
    },
  },
  {
    name: 'FragmentScreens',
    component: FragmentScreens,
    path: WEB_ROUTE_PATHS.FragmentScreens,
    convertParams: props => {
      const formattedExtras =
        typeof props.extras === 'string'
          ? (() => {
              try {
                return JSON.parse(props.extras as string);
              } catch {
                return {};
              }
            })()
          : props.extras;

      return {
        instanceId: props.instanceId,
        ...formattedExtras,
      };
    },
  },
  {
    name: 'WebViewScreen',
    component: WebViewScreen,
    path: '/webview',
  },
  ...devOnlyScreens,
];
